export default {"src":"/_next/static/media/ski_school.dfcab93e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};